import { refreshProfileWalkInsCache, walkInQueryKeys, walkInQueryOptions } from '@/hooks/queries/walk-in.queries';
import { normalizeProfileWalkInsResponse } from '@/lib/profile-walk-ins';
import { WalkInService } from '@/services/walk-in.service';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export function useProfileWalkIns(viewerId?: string | null, enabled = true) {
  const { data, isError, isFetching, isLoading, refetch } = useQuery(walkInQueryOptions.profile(viewerId, enabled));
  const normalizedResponse = normalizeProfileWalkInsResponse(data);

  return {
    activeWalkIns: normalizedResponse.activeWalkIns,
    counters: normalizedResponse.counters,
    historyWalkIns: normalizedResponse.historyWalkIns,
    isError,
    isFetching,
    isLoading,
    refetch,
    walkIns: normalizedResponse.walkIns,
  };
}

export function useCancelProfileWalkIn(viewerId?: string | null) {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (walkInId: string) => WalkInService.cancel(walkInId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: walkInQueryKeys.all });
      await refreshProfileWalkInsCache(queryClient, viewerId);
    },
  });

  return {
    cancelWalkIn: mutation.mutateAsync,
    error: mutation.error,
    isError: mutation.isError,
    isPending: mutation.isPending,
    isSuccess: mutation.isSuccess,
  };
}
